import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { ensureAbsoluteUrl } from '../../../utils/url'
import styles from './CharityProfileRightSidebar.module.scss'

export default function CharityProfileRightSidebar({
  externalDonationUrl,
  amazonWishlistUrl,
  onCivDonateClick,
}) {
  const { t } = useTranslation()
  const externalUrl = ensureAbsoluteUrl(externalDonationUrl)
  const amazonUrl = ensureAbsoluteUrl(amazonWishlistUrl)

  const showDonate = !!(externalUrl || onCivDonateClick)
  const showAmazon = !!amazonUrl

  if (!showDonate && !showAmazon) {
    return null
  }

  return (
    <div className={styles.sidebar}>
      <section className={styles.section}>
        <div className={styles.titleRow}>
          <h3 className={styles.titleText}>
            {t('charities.profile.supportTitle', 'Support this charity')}
          </h3>
        </div>
        <hr className={styles.divider} />
        <div className={styles.actions}>
          {externalUrl ? (
            <a
              className={styles.donateButton}
              href={externalUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('charities.profile.donate', 'Donate')}
            </a>
          ) : onCivDonateClick ? (
            <button
              type="button"
              className={styles.donateButton}
              onClick={onCivDonateClick}
            >
              {t('charities.profile.donateCiv', 'Donate with CIV')}
            </button>
          ) : null}
          {showAmazon ? (
            <a
              className={styles.amazonButton}
              href={amazonUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('charities.profile.amazonWishlist', 'Amazon Wish List')}
            </a>
          ) : null}
        </div>
      </section>
    </div>
  )
}

CharityProfileRightSidebar.propTypes = {
  externalDonationUrl: PropTypes.string,
  amazonWishlistUrl: PropTypes.string,
  onCivDonateClick: PropTypes.func,
}
